import {
  DEPOT_ALL_REQUEST,
  DEPOT_ALL_SUCCESS,
  DEPOT_ALL_FAIL,
  DEPOT_ALL_RESET,
  DEPOT_DETAIL_REQUEST,
  DEPOT_DETAIL_SUCCESS,
  DEPOT_DETAIL_FAIL,
  DEPOT_DETAIL_RESET,
  PDF_REQUEST,
  PDF_SUCCESS,
  PDF_FAIL,
  PDF_RESET,
  PDFMPS_REQUEST,
  PDFMPS_SUCCESS,
  PDFMPS_FAIL,
  PDFMPS_RESET,
  PDF_DOWNLOAD_REQUEST,
  PDF_DOWNLOAD_SUCCESS,
  PDF_DOWNLOAD_FAIL,
  PDF_DOWNLOAD_RESET,
} from "../constants/depot_constant";

export const depotListReducers = (
  state = { depots: { depot: [] } },
  action
) => {
  switch (action.type) {
    case DEPOT_ALL_REQUEST:
      return { loading: true };
    case DEPOT_ALL_SUCCESS:
      return { loading: false, depots: action.payload };
    case DEPOT_ALL_FAIL:
      return { loading: false, error: action.payload };
    case DEPOT_ALL_RESET:
      return { depots: [] };

    default:
      return state;
  }
};

export const depotDetailReducer = (state = {}, action) => {
  switch (action.type) {
    case DEPOT_DETAIL_REQUEST:
      return { ...state, loading: true };

    case DEPOT_DETAIL_SUCCESS:
      return { loading: false, depots: action.payload };

    case DEPOT_DETAIL_FAIL:
      return { loading: false, error: action.payload };

    case DEPOT_DETAIL_RESET:
      return {};
    default:
      return state;
  }
};

export const pdfPageReducer = (state = {}, action) => {
  switch (action.type) {
    case PDF_REQUEST:
      return { ...state, loading: true };

    case PDF_SUCCESS:
      return { loading: false, pdf: action.payload };

    case PDF_FAIL:
      return { loading: false, error: action.payload };

    case PDF_RESET:
      return {};
    default:
      return state;
  }
};

export const pdfPageMPSReducer = (state = {}, action) => {
  switch (action.type) {
    case PDFMPS_REQUEST:
      return { ...state, loading: true };

    case PDFMPS_SUCCESS:
      return { loading: false, pdfMPS: action.payload };

    case PDFMPS_FAIL:
      return { loading: false, error: action.payload };

    case PDFMPS_RESET:
      return {};
    default:
      return state;
  }
};

export const pdfPrintReducer = (state = {}, action) => {
  switch (action.type) {
    case PDF_DOWNLOAD_REQUEST:
      return { ...state, loading: true };

    case PDF_DOWNLOAD_SUCCESS:
      return { loading: false, pdfP: action.payload };

    case PDF_DOWNLOAD_FAIL:
      return { loading: false, error: action.payload };

    case PDF_DOWNLOAD_RESET:
      return {};
    default:
      return state;
  }
};
